export const environment = {
    production: true,
    firebase: {
        apiKey: 'AIzaSyCS6ZXCB5gl0A8mINdbSDifcRRmy6xoouI',
        authDomain: 'desarrollodtic-ed4b8.firebaseapp.com',
        projectId: 'desarrollodtic-ed4b8',
        storageBucket: 'desarrollodtic-ed4b8.appspot.com',
        messagingSenderId: '465237050407',
        appId: '1:465237050407:web:6c6bba4fa2578d532b3a02',
        measurementId: 'G-MK0K7LYB7N',
    },
    backend: 'https://controladorexterno.uv.cl/portalAdmision',
    RESULTADO_POSTULACION: 'https://resultadospostulacion.uv.cl',
    CERTIFICADOS: 'https://descargacertificado.uv.cl',
    sentry: {

        dns: 'https://e8a1c984efed46aeb1e6f092d38d2a36@o560748.ingest.sentry.io/4504237340819456',
        tracingOrigins: ['https://portaladmision.uv.cl/']
    },
    analytics: 'G-9B9S0B5HW6'
};
